module.exports = __webpack_public_path__ + "static/media/logo.e5870378.png";